var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"GameBankvaultQuizViewDebug"},[_vm._v("\n    GameBankvaultQuizViewDebug\n    "),_c('ButtonPlain',{attrs:{"label":"fillAllDigits"},on:{"click":function($event){return _vm.dbgFillAllDigits()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }